import React, { useState, useEffect } from 'react';
import './SelectDepth.style.css';
import { RightOutlined } from '@ant-design/icons';

const SelectDepth = ({
  items = [],
  depthWidth,
  maxHeight = 160,
  onSelect = () => {},
  onFinish = () => {},
  defaultCategoryId,
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [selectedCategories, setSelectedCategories] = useState([]);

  /* ===== Function ===== */

  // 수정된 부분: 기본 카테고리를 찾아 선택하는 함수 추가
  const findCategoryById = (categories, categoryId) => {
    for (let category of categories) {
      if (category.key === categoryId) {
        return category;
      }
      if (category.children.length > 0) {
        const found = findCategoryById(category.children, categoryId);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  useEffect(() => {
    if (defaultCategoryId) {
      const initialCategory = findCategoryById(items, defaultCategoryId);
      if (initialCategory) {
        let parents = [];
        let current = initialCategory;
        while (current) {
          parents.unshift(current);
          current = current.parents_id
            ? findCategoryById(items, current.parents_id)
            : null;
        }
        setSelectedCategories(parents);
      }
    }
  }, [defaultCategoryId, items]);

  const calculateDepth = (data) => {
    if (!data || data.length === 0) return 0;
    let maxDepth = 0;
    data.forEach((item) => {
      const depth = calculateDepth(item.children);
      if (depth > maxDepth) {
        maxDepth = depth;
      }
    });
    return maxDepth + 1;
  };

  const handleItemSelected = (item, depth) => {
    const newSelectedCategories = [...selectedCategories];
    newSelectedCategories[depth] = item;
    setSelectedCategories(newSelectedCategories.slice(0, depth + 1));
  };

  const SelectDepthItem = ({ data, depth, onItemSelected }) => {
    return (
      <>
        <ul>
          {data.map((item, index) => (
            <li
              key={`${depth}_${index}`}
              onClick={() => onItemSelected(item, depth)}
              style={{
                background:
                  selectedCategories[depth]?.key === item.key && '#F4F4F5',
              }}
            >
              <p>{item.title}</p>
              {depth + 1 !== maxDepth && <RightOutlined />}
            </li>
          ))}
        </ul>
      </>
    );
  };

  /* ===== Variable ===== */
  const maxDepth = calculateDepth(items);

  /* ===== Hooks ===== */
  /**
   * 선택값 리턴
   * --
   */
  useEffect(() => {
    onSelect(selectedCategories);
  }, [selectedCategories, onSelect]);

  /**
   * 마지막 depth 선택시 리턴
   * --
   */
  useEffect(() => {
    if (selectedCategories.length === maxDepth && onFinish) {
      const call = (d) => {
        onFinish(d);
      };
      call(selectedCategories);
    }
  }, [selectedCategories, maxDepth, onFinish]);

  /* ===== Hooks ===== */

  /* ===== Render ===== */
  return (
    <div className="select_depth_layout">
      {Array.from({ length: maxDepth }).map((_, depth) => {
        const currentData =
          depth === 0 ? items : selectedCategories[depth - 1]?.children;
        return currentData ? (
          <div
            key={depth}
            className="select_depth_container"
            style={{
              width: depthWidth ?? `calc(100% / ${maxDepth})`,
              height: maxHeight,
            }}
          >
            <SelectDepthItem
              data={currentData}
              depth={depth}
              onItemSelected={handleItemSelected}
            />
          </div>
        ) : null;
      })}
      {selectedCategories.length + 1 < maxDepth && (
        <div
          className="select_depth_container"
          style={{
            width: depthWidth ?? `calc(100% / ${maxDepth})`,
            height: maxHeight,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <p>이전 카테고리를 선택해주세요.</p>
        </div>
      )}
    </div>
  );
};

export default SelectDepth;
